



























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

/**
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
 */

const dateTimeFormats = {
  long: {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  },
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  },
  time: {
    hour: 'numeric',
    minute: 'numeric'
  },
  monthYear: {
    year: 'numeric',
    month: 'long'
  }
}

@Component({
  name: 'DateTime'
})
export default class extends Vue {
  texts: any = {}
  visibleTooltip: boolean = false

  @Prop() value: any
  @Prop() locale: string
  @Prop({ default: 'long' }) format: string
  @Prop({ default: false }) tooltip: boolean
  @Prop() options: object

  get userLocale() {
    return this.$i18n.locale
  }

  get formatedValue() {
    const locale = this.$i18n.locale
    let options = dateTimeFormats[this.format]
    if (this.options) options = Object.assign({}, options, this.options)
    const value: Date = new Date(this.value)
    try {
      return new Intl.DateTimeFormat(locale, options).format(value)
    } catch (error) {
      console.log(this.value)
      console.log(error)
      return null
    }
  }
}
